/* eslint-disable prefer-const  */

function optionValueSort(sortOrder, a, b) {
  return sortOrder.indexOf(a.option_type_id) < sortOrder.indexOf(b.option_type_id) ? -1 : 1;
}

function getDefaultSet(variantMap, depth) {
  let index = 0;
  let output = [];
  var vmRef = variantMap;

  while (index++ < depth) {
    let key = Object.keys(vmRef)[0];
    vmRef = vmRef[key];
    output.push(key);
  }

  return output;
}

function getPrices(variant) {
  return {
    price: +variant.price,
    salePrice: +variant.sale_price,
    onSale: variant['on_sale?'],
    inStock: variant.in_stock,
    totalOnHand: variant.total_on_hand
  };
}

var ProductOptions = {
  getVariantData: function (product) {
    product = product || {};
    const variants = product.variants || [];
    const optionTypes = product.option_types || [];
    let variantMap = {};
    let optionValues = {};
    let priceTable = {};
    let optionOrder = {};
    const sortOrder = optionTypes.map(function (ot) {
      return ot.id;
    });

    let sortFunc = optionValueSort.bind(null, sortOrder);

    variants.forEach(function (variant) {
      let vmRef = variantMap;
      const depth = variant.option_values.length;

      variant.option_values.sort(sortFunc).forEach(function (ov, index) {
        if (!vmRef.hasOwnProperty(ov.id)) {
          vmRef[ov.id] = {};

          // Option values are returned from API in the correct sorted order
          // so we're saving the option order based on the order it's provided
          if (!optionValues[ov.id]) {
            if (optionOrder[ov.option_type_id]) {
              optionOrder[ov.option_type_id].push(ov.id.toString());
            } else {
              optionOrder[ov.option_type_id] = [ov.id.toString()];
            }
          }
        }

        if (index < depth - 1) {
          vmRef = vmRef[ov.id];
        } else {
          vmRef[ov.id] = variant;
        }

        optionValues[ov.id] = ov;
      });
      // Add to price table
      priceTable[variant.id] = getPrices(variant);
    });

    // Add master variant to price table
    if (product.master) {
      priceTable[product.master.id] = getPrices(product.master);
    }

    return {
      optionOrder: optionOrder,
      variantMap: variantMap,
      optionValues: optionValues,
      defaultOptionValues: getDefaultSet(variantMap, optionTypes.length),
      priceTable: priceTable
    };
  },

  getPersonalizationData: function (product) {
    product = product || {};
    let personalizationMap = {};
    const personalizations = product.personalizations || [];

    personalizations.forEach(function (personalization) {
      if (personalization.kind === 'list') {
        let priceTable = {};
        personalization.option_values.forEach(function (ov) {
          priceTable[ov.id] = ov.increase_by;
        });
        personalization.priceTable = priceTable;
      }
      personalizationMap[personalization.id] = personalization;
    });

    return {
      personalizationMap: personalizationMap
    };
  }
};

export default ProductOptions;
